__webpack_require__.p = "/Pharmacy-app/";